module.exports = __webpack_public_path__ + "img/call-center@3x.4356116c.png";